import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modify-ticket',
  templateUrl: './modify-ticket.component.html',
  styleUrls: ['./modify-ticket.component.css']
})
export class ModifyTicketComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
